import { render, staticRenderFns } from "./logoLoading.vue?vue&type=template&id=ff89faf2&scoped=true"
import script from "./logoLoading.vue?vue&type=script&lang=js"
export * from "./logoLoading.vue?vue&type=script&lang=js"
import style0 from "./logoLoading.vue?vue&type=style&index=0&id=ff89faf2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff89faf2",
  null
  
)

export default component.exports